export default "__VITE_ASSET__CRB9fWL3__"